/* Rule filters, above the list. Chips rather than a dropdown: the counts are
   the point — a reader should see that four facilities are filling short
   without having to open anything. */
.filters { display: flex; flex-wrap: wrap; gap: 6px; justify-content: flex-end; max-width: 720px; }

.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border: 1px solid var(--border-chip);
  border-radius: var(--radius-pill);
  background: #fff;
  color: var(--text-pill);
  font: inherit;
  font-size: 11px;
  line-height: 16px;
  cursor: pointer;
}
.chip:hover { background: var(--bg-chip); }
.chipOn { background: var(--bg-nav-active); border-color: var(--bg-nav-active); color: #fff; }
.chipCount { opacity: 0.75; font-variant-numeric: tabular-nums; }

/* ---- the worklist ---- */
.list { list-style: none; margin: 0; padding: 0; }

.row { border-bottom: 1px solid var(--border-cell); }
.row:last-child { border-bottom: 0; }

.rowHead {
  display: grid;
  grid-template-columns: 4px minmax(0, 1fr) auto 150px;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 12px 2px;
  border: 0;
  background: transparent;
  font: inherit;
  text-align: left;
  cursor: pointer;
}
.rowHead:hover { background: var(--bg-pill); }
.rowHead:focus-visible { outline: 2px solid #342885; outline-offset: -2px; }

/* Severity is rank WITHIN a rule, not an absolute rupee threshold — the worst
   stock-outs and the worst blocked capital both deserve the top band. */
.sev { display: block; width: 4px; height: 30px; border-radius: 2px; background: #e3e6ea; }
.sev3 { background: var(--badge-high-bg); }
.sev2 { background: var(--badge-med-bg); }
.sev1 { background: #cfd6de; }

.rowMain { min-width: 0; }
.rowTitle {
  display: block;
  color: var(--text-title);
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rowSub {
  display: block;
  color: var(--text-muted);
  font-size: 11px;
  line-height: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rowTags { display: flex; align-items: center; gap: 8px; flex: none; }
.team { color: var(--text-muted); font-size: 11px; white-space: nowrap; }

.rowValue { text-align: right; }
.value {
  display: block;
  color: var(--text-title);
  font-size: 14px;
  font-weight: 600;
  line-height: 19px;
  font-variant-numeric: tabular-nums;
}
/* The unit is printed under every figure, because the page deliberately mixes
   kinds of money and a bare number invites the reader to add them up. */
.valueLabel { display: block; color: var(--text-muted); font-size: 10px; line-height: 14px; }

.detail { padding: 4px 2px 16px 22px; }

.rule {
  margin: 0 0 10px;
  color: var(--text-value);
  font-size: 12px;
  line-height: 18px;
}

.evidence {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 10px 18px;
  margin: 0;
}
.evidenceItem > dt {
  color: var(--text-muted);
  font-size: 10px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  line-height: 14px;
}
.evidenceItem > dd {
  margin: 1px 0 0;
  color: var(--text-value);
  font-size: 13px;
  line-height: 18px;
  font-variant-numeric: tabular-nums;
}

.detailFoot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;
  padding-top: 9px;
  border-top: 1px dashed var(--border-cell);
}

/* Naming the table a figure came from is what lets someone check it. */
.source { color: var(--text-muted); font-size: 10px; font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }

.goto {
  border: 0;
  background: transparent;
  padding: 0;
  color: #342885;
  font: inherit;
  font-size: 12px;
  cursor: pointer;
}
.goto:hover { text-decoration: underline; }

.rowSkeleton {
  height: 44px;
  margin-bottom: 8px;
  border-radius: 6px;
  background: linear-gradient(90deg, #f2f4f7 25%, #e9edf3 37%, #f2f4f7 63%);
  background-size: 400% 100%;
  animation: shimmer 1.3s ease-in-out infinite;
}
@keyframes shimmer {
  0% { background-position: 100% 50%; }
  100% { background-position: 0 50%; }
}

/* ---- source health ---- */
.sources { list-style: none; margin: 0; padding: 4px 18px 14px; }
.sources .source { font-family: inherit; font-size: 12px; }
.sources > li {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 6px 0;
  border-bottom: 1px solid var(--border-cell);
}
.sources > li:last-child { border-bottom: 0; }
.sourceName { flex: 1 1 auto; color: var(--text-value); font-size: 12px; }
.sourceRows { color: var(--text-muted); font-size: 12px; font-variant-numeric: tabular-nums; }
.dotOk { width: 7px; height: 7px; border-radius: 50%; background: var(--delta-up); flex: none; }
.dotBad { width: 7px; height: 7px; border-radius: 50%; background: var(--delta-down); flex: none; }
